import React from 'react';
import Icon from '../../../components/AppIcon';

const MarketAnalysis = ({ market }) => {
  const expertAnalyses = [
  {
    id: 1,
    expert: 'Dr. Rajesh Kumar',
    designation: 'Chief Commodity Analyst',
    organization: 'National Sugar Institute',
    image: {
      url: "https://img.rocket.new/generatedImages/rocket_gen_img_168fffdb3-1763294747480.png",
      alt: 'Professional male analyst in business attire with confident expression in modern office setting'
    },
    rating: 4.9,
    followers: '12.5K',
    analysis: 'Current market trends indicate a bullish outlook for white sugar M30 in Q4 2025. Strong domestic demand coupled with controlled exports suggest sustained price support above ₹3,800 per quintal. Mills should focus on forward booking to lock in favorable rates.',
    predictions: [
    { timeframe: 'Short Term (1-3 months)', outlook: 'Bullish', confidence: 85 },
    { timeframe: 'Medium Term (3-6 months)', outlook: 'Neutral', confidence: 70 },
    { timeframe: 'Long Term (6-12 months)', outlook: 'Bullish', confidence: 75 }],

    keyFactors: [
    'Export quota regulations',
    'Monsoon impact on production',
    'Ethanol blending mandates',
    'International price movements'],

    timestamp: '4 hours ago'
  },
  {
    id: 2,
    expert: 'Ms. Priya Sharma',
    designation: 'Market Research Director',
    organization: 'Indian Sugar Mills Association',
    image: {
      url: "https://img.rocket.new/generatedImages/rocket_gen_img_149c1f2d2-1765794380669.png",
      alt: 'Professional female analyst with glasses reviewing market data on computer in corporate office'
    },
    rating: 4.7,
    followers: '9.8K',
    analysis: 'Maharashtra\'s record production this season has created temporary downward pressure on spot prices. However, improved logistics and storage infrastructure should stabilize prices by mid-quarter. Recommend hedging strategies for large volume traders.',
    predictions: [
    { timeframe: 'Short Term (1-3 months)', outlook: 'Bearish', confidence: 78 },
    { timeframe: 'Medium Term (3-6 months)', outlook: 'Neutral', confidence: 82 },
    { timeframe: 'Long Term (6-12 months)', outlook: 'Bullish', confidence: 80 }],

    keyFactors: [
    'Regional production surplus',
    'Storage capacity utilization',
    'Transportation bottlenecks',
    'Festival season demand'],

    timestamp: '6 hours ago'
  },
  {
    id: 3,
    expert: 'Mr. Anand Patel',
    designation: 'Senior Trading Strategist',
    organization: 'Commodity Trading Corp',
    image: {
      url: "https://img.rocket.new/generatedImages/rocket_gen_img_10c585516-1774121680633.png",
      alt: 'Experienced male trader in formal wear analyzing financial charts on multiple monitors'
    },
    rating: 4.8,
    followers: '15.2K',
    analysis: 'Global sugar prices hitting 5-year highs present excellent arbitrage opportunities for Indian exporters. Current international-domestic price differential of ₹800-1000 per quintal makes exports highly profitable despite quota constraints.',
    predictions: [
    { timeframe: 'Short Term (1-3 months)', outlook: 'Bullish', confidence: 90 },
    { timeframe: 'Medium Term (3-6 months)', outlook: 'Bullish', confidence: 85 },
    { timeframe: 'Long Term (6-12 months)', outlook: 'Neutral', confidence: 65 }],

    keyFactors: [
    'International supply constraints',
    'Currency exchange rates',
    'Freight cost dynamics',
    'Export documentation timelines'],

    timestamp: '8 hours ago'
  }];


  const marketInsights = [
  {
    title: 'Production Outlook',
    metric: '+8.5%',
    description: 'Expected increase in all-India sugar production for 2024-25 season',
    icon: 'Factory',
    trend: 'up'
  },
  {
    title: 'Export Potential',
    metric: '6.2M MT',
    description: 'Estimated export capacity for current sugar year',
    icon: 'Ship',
    trend: 'up'
  },
  {
    title: 'Ethanol Diversion',
    metric: '22%',
    description: 'Sugar diverted to ethanol production vs last year',
    icon: 'Droplet',
    trend: 'up'
  },
  {
    title: 'Price Volatility',
    metric: 'Moderate',
    description: 'Market stability index for current quarter',
    icon: 'Activity',
    trend: 'neutral'
  }];


  const getOutlookColor = (outlook) => {
    switch (outlook?.toLowerCase()) {
      case 'bullish':
        return 'text-green-600 bg-green-50 border-green-200';
      case 'bearish':
        return 'text-red-600 bg-red-50 border-red-200';
      case 'neutral':
        return 'text-blue-600 bg-blue-50 border-blue-200';
      default:
        return 'text-gray-600 bg-gray-50 border-gray-200';
    }
  };

  return (
    <div className="space-y-6">
      {/* Market Insights Overview */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {marketInsights?.map((insight, index) =>
        <div key={index} className="bg-card border border-border rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <Icon name={insight?.icon} size={24} className="text-primary" />
              {insight?.trend === 'up' &&
            <Icon name="TrendingUp" size={16} className="text-green-500" />
            }
            </div>
            <div className="text-2xl font-bold text-foreground mb-1">{insight?.metric}</div>
            <h4 className="font-semibold text-foreground text-sm mb-1">{insight?.title}</h4>
            <p className="text-xs text-muted-foreground">{insight?.description}</p>
          </div>
        )}
      </div>

      {/* Expert Analyses */}
      <div className="space-y-6">
        {expertAnalyses?.map((analysis) =>
        <div key={analysis?.id} className="bg-card border border-border rounded-lg overflow-hidden">
            <div className="p-6 space-y-6">
              {/* Expert Header */}
              <div className="flex items-start gap-4">
                <img
                src={analysis?.image?.url}
                alt={analysis?.image?.alt}
                className="w-16 h-16 rounded-full object-cover border-2 border-primary" />

                <div className="flex-1">
                  <h3 className="text-lg font-bold text-foreground">{analysis?.expert}</h3>
                  <p className="text-sm text-muted-foreground">{analysis?.designation}</p>
                  <p className="text-sm text-muted-foreground">{analysis?.organization}</p>
                  <div className="flex items-center gap-4 mt-2">
                    <div className="flex items-center gap-1">
                      <Icon name="Star" size={14} className="text-yellow-500 fill-yellow-500" />
                      <span className="text-sm font-medium text-foreground">{analysis?.rating}</span>
                    </div>
                    <div className="flex items-center gap-1 text-sm text-muted-foreground">
                      <Icon name="Users" size={14} />
                      <span>{analysis?.followers} followers</span>
                    </div>
                    <div className="flex items-center gap-1 text-sm text-muted-foreground">
                      <Icon name="Clock" size={14} />
                      <span>{analysis?.timestamp}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Analysis Content */}
              <div className="bg-muted/30 rounded-lg p-4">
                <div className="flex items-start gap-2 mb-3">
                  <Icon name="MessageSquare" size={18} className="text-primary flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-foreground mb-2">Expert Commentary</h4>
                    <p className="text-sm text-foreground leading-relaxed">
                      {analysis?.analysis}
                    </p>
                  </div>
                </div>
              </div>

              {/* Market Predictions */}
              <div>
                <h4 className="font-semibold text-foreground mb-3 flex items-center gap-2">
                  <Icon name="Target" size={18} className="text-primary" />
                  Market Predictions
                </h4>
                <div className="space-y-3">
                  {analysis?.predictions?.map((prediction, idx) =>
                <div key={idx} className="flex items-center justify-between gap-4">
                      <span className="text-sm text-muted-foreground flex-1">
                        {prediction?.timeframe}
                      </span>
                      <span className={`px-3 py-1 rounded-full text-xs font-medium border ${getOutlookColor(prediction?.outlook)}`}>
                        {prediction?.outlook}
                      </span>
                      <div className="flex items-center gap-2 flex-shrink-0">
                        <div className="w-24 bg-muted rounded-full h-2">
                          <div
                        className="bg-primary h-2 rounded-full"
                        style={{ width: `${prediction?.confidence}%` }}>
                      </div>
                        </div>
                        <span className="text-xs font-medium text-muted-foreground w-10">
                          {prediction?.confidence}%
                        </span>
                      </div>
                    </div>
                )}
                </div>
              </div>

              {/* Key Factors */}
              <div>
                <h4 className="font-semibold text-foreground mb-3 flex items-center gap-2">
                  <Icon name="Lightbulb" size={18} className="text-primary" />
                  Key Factors to Watch
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  {analysis?.keyFactors?.map((factor, idx) =>
                <div key={idx} className="flex items-center gap-2 text-sm text-foreground">
                      <Icon name="CheckCircle" size={14} className="text-green-500 flex-shrink-0" />
                      <span>{factor}</span>
                    </div>
                )}
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex items-center gap-3 pt-4 border-t border-border">
                <button className="flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors">
                  <Icon name="UserPlus" size={16} />
                  <span>Follow Expert</span>
                </button>
                <button className="flex items-center gap-2 px-4 py-2 bg-muted text-foreground rounded-lg text-sm font-medium hover:bg-muted/80 transition-colors">
                  <Icon name="Share2" size={16} />
                  <span>Share Analysis</span>
                </button>
                <button className="flex items-center gap-2 px-4 py-2 bg-muted text-foreground rounded-lg text-sm font-medium hover:bg-muted/80 transition-colors ml-auto">
                  <Icon name="FileDown" size={16} />
                  <span>Download Report</span>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>);

};

export default MarketAnalysis;